export enum EDMRTypes {
    billing = 'billing',
    payment = 'payment',
}

export enum EDMRActions {
    payStart = 'payStart',
    payError = 'payError',
    pageLoad = 'pageLoad',
    resizeFrame = 'resizeFrame',
    refreshWindow = 'refreshWindow',
    closeWindow = 'closeWindow',
    paySuccess = 'paySuccess',
    payCancel = 'payCancel',
    paySubmit = 'paySubmit',
    putPixel = 'putPixel',
    threeDSPage = '3dsPage',
    threeDSFinish = '3dsFinish',
}
